<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-menu-mailServer',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowMailServerUser',
      'isShowMailServerHost',
      'isShowMailServerMailFrom',
      'isShowMailServerProtocol',
      'isShowMailServerPort',
      'isShowMailServerAuth',
      'isShowMailServerIdClient',
      'isShowMailServerIdTenant',
      'isShowMailServerSaveToSentItems',
      'isShowMailServerValidityDateTo'
    ])
  },
  methods: {
    ...mapActions([
      'isShowMailServerUserAction',
      'isShowMailServerHostAction',
      'isShowMailServerMailFromAction',
      'isShowMailServerProtocolAction',
      'isShowMailServerPortAction',
      'isShowMailServerAuthAction',
      'isShowMailServerIdClientAction',
      'isShowMailServerIdTenantAction',
      'isShowMailServerSaveToSentItemsAction',
      'isShowMailServerValidityDateToAction',
      'canAdminIndraAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'user':
          isShow = !this.isShowMailServerUser
          this.isShowMailServerUserAction(isShow)
          break
        case 'host':
          isShow = !this.isShowMailServerHost
          this.isShowMailServerHostAction(isShow)
          break
        case 'mailfrom':
          isShow = !this.isShowMailServerMailFrom
          this.isShowMailServerMailFromAction(isShow)
          break
        case 'protocol':
          isShow = !this.isShowMailServerProtocol
          this.isShowMailServerProtocolAction(isShow)
          break
        case 'port':
          isShow = !this.isShowMailServerPort
          this.isShowMailServerPortAction(isShow)
          break
        case 'auth':
          isShow = !this.isShowMailServerAuth
          this.isShowMailServerAuthAction(isShow)
          break
        case 'idClient':
          isShow = !this.isShowMailServerIdClient
          this.isShowMailServerIdClientAction(isShow)
          break
        case 'idTenant':
          isShow = !this.isShowMailServerIdTenant
          this.isShowMailServerIdTenantAction(isShow)
          break
        case 'saveToSentItems':
          isShow = !this.isShowMailServerSaveToSentItems
          this.isShowMailServerSaveToSentItemsAction(isShow)
          break
        case 'validityDateTo':
          isShow = !this.isShowMailServerValidityDateTo
          this.isShowMailServerValidityDateToAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('mailServer.mailServer_table.mailfrom'), value: 'mailfrom', show: this.isShowMailServerMailFrom
        }, {
          text: this.$t('mailServer.mailServer_table.protocol'), value: 'protocol', show: this.isShowMailServerProtocol
        }, {
          text: this.$t('mailServer.mailServer_table.auth'), value: 'auth', show: this.isShowMailServerAuth
        }, {
          text: this.$t('mailServer.mailServer_table.user'), value: 'user', show: this.isShowMailServerUser
        }, {
          text: this.$t('mailServer.mailServer_table.host'), value: 'host', show: this.isShowMailServerHost
        }, {
          text: this.$t('mailServer.mailServer_table.port'), value: 'port', show: this.isShowMailServerPort
        }, {
          text: this.$t('mailServer.mailServer_table.idClient'), value: 'idClient', show: this.isShowMailServerIdClient
        }, {
          text: this.$t('mailServer.mailServer_table.idTenant'), value: 'idTenant', show: this.isShowMailServerIdTenant
        }, {
          text: this.$t('mailServer.mailServer_table.saveToSentItems'), value: 'saveToSentItems', show: this.isShowMailServerSaveToSentItems
        }, {
          text: this.$t('mailServer.mailServer_table.validityDateTo'), value: 'validityDateTo', show: this.isShowMailServerValidityDateTo
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
